import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './main.css'
import { Tabs } from './screens/Tabs'
import { TonConnectUIProvider } from '@tonconnect/ui-react'
import { Provider } from 'react-redux'
import { store } from './state/store'
import { IconSprite } from './components/IconSprite'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <TonConnectUIProvider manifestUrl="https://cards-collection-game.vercel.app/tonconnect-manifest.json">
        <div className="app-screen">
          <IconSprite />
          <Tabs />
        </div>
      </TonConnectUIProvider>
    </Provider>
  </StrictMode>
)
